import {playerContainerFocused} from '../utils/playerEventsHelper';
import videojs from 'video.js';
// import './SeekButton.css';

let seekTimeout: any = null;
let forwardAccumulatedSeekTime = 0;
let backwardAccumulatedSeekTime = 0;

function getSeekDisplay(
  player: any,
  direction: 'forward' | 'backward'
): HTMLElement | null {
  return player.el().querySelector(`.seek-time-display.${direction}`);
}

function updateSeekDisplay(
  player: any,
  time: number,
  direction: 'forward' | 'backward'
) {
  const display = getSeekDisplay(player, direction);
  // Pause player when seek is in progress.
  if (!player.paused()) {
    player.pause();
  }
  if (display) {
    display.textContent = `${direction === 'forward' ? '+' : '-'}${Math.abs(
      time
    )}s`;
    display.style.display = 'block';
  }
}

function hideSeekDisplay(player: any, direction: 'forward' | 'backward') {
  const display = getSeekDisplay(player, direction);
  if (display) {
    display.style.display = 'none';
  }
}

function debouncedSeek(timeSec: number, player: any) {
  clearTimeout(seekTimeout);

  if (timeSec > 0) {
    if (backwardAccumulatedSeekTime !== 0) {
      hideSeekDisplay(player, 'backward');
      backwardAccumulatedSeekTime = 0;
    }
    forwardAccumulatedSeekTime += timeSec;
    updateSeekDisplay(player, forwardAccumulatedSeekTime, 'forward');
  } else {
    // timeSec < 0
    if (forwardAccumulatedSeekTime !== 0) {
      hideSeekDisplay(player, 'forward');
      forwardAccumulatedSeekTime = 0;
    }
    backwardAccumulatedSeekTime += timeSec;
    updateSeekDisplay(player, backwardAccumulatedSeekTime, 'backward');
  }

  seekTimeout = setTimeout(() => {
    const totalSeek = forwardAccumulatedSeekTime + backwardAccumulatedSeekTime;
    if (totalSeek !== 0) {
      seek(totalSeek, player);
      if (player.paused()) {
        player.play();
      }
    }
    hideSeekDisplay(player, 'forward');
    hideSeekDisplay(player, 'backward');
    forwardAccumulatedSeekTime = 0;
    backwardAccumulatedSeekTime = 0;
  }, 1000);
}

export function addSeekButtons(playerRef: any) {
  // seekControlsLoadedet  = true;
  const player = playerRef; // Player instance

  /* Hiding default play button */
  player.removeChild('PlayToggle');
  player.removeChild('PictureInPictureToggle');
  player.removeChild('BigPlayButton');

  const Button = videojs.getComponent('Button');
  const seekTime = (timeSec: number): object => {
    return {
      clickHandler: () => debouncedSeek(timeSec, playerRef)
    };
  };
  const skipForButton = new Button(player, seekTime(10));
  const skipBackButton = new Button(player, seekTime(-10));
  skipForButton.addClass('vjs-skip-forward');
  skipForButton.controlText('Forward 10s');
  skipBackButton.addClass('vjs-skip-backward');
  skipBackButton.controlText('Backward 10s');

  const Component = videojs.getComponent('Component');

  /* Creating new wrapper component */
  const myWrapperComp = new Component(player);

  /* Adding wrapper component to player */
  player.addChild(myWrapperComp).addClass('vjs-skip-wrapper');

  /* Adding child component to wrapper component */
  myWrapperComp.addChild(skipBackButton);
  myWrapperComp.addChild('PlayToggle').addClass('vjs-playing');
  myWrapperComp.addChild(skipForButton);

  // Add display elements for seek time
  const forwardDisplay = document.createElement('div');
  forwardDisplay.className = 'seek-time-display forward';
  forwardDisplay.style.display = 'none';
  skipForButton.el().appendChild(forwardDisplay);

  const backwardDisplay = document.createElement('div');
  backwardDisplay.className = 'seek-time-display backward';
  backwardDisplay.style.display = 'none';
  skipBackButton.el().appendChild(backwardDisplay);

  // Add styles for the display
  const style = document.createElement('style');
  style.textContent = `
    .seek-time-display {
      position: absolute;
      top: 90%;
      transform: translateY(-60%);
      color: white;
      padding: 3px 9px;
      font-size: 20px;
      font-weight:600;
      white-space: nowrap;
      pointer-events: none;
      &.forward {
        right: 100%;
        top: 100%;
      }
      &.backward {
        left: 100%;
        top: 100%
      }
      @media screen and (max-width: 599px) and (orientation: portrait) {
        transform: translateY(-50%);
        font-size: 13px;
        &.forward {
          right: 100%;
          top: 100%
        }
        &.backward {
          left: 100%;
          top: 100%
        }
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
      }
      @media screen and (max-device-width: 1024px) and (orientation: landscape) {
        font-size: 15px;
        &.forward {
          right: 150%;
        }
        &.backward {
          left: 150%;
        }
      }
    }
  `;
  player.el().appendChild(style);
}

export function seek(
  secs: number,
  videoPlayer: {hotkeys?: (event: any) => void; currentTime?: any}
) {
  if (videoPlayer) {
    window.autoSeek = true;
    let time = videoPlayer.currentTime() + secs;
    if (time < 0) time = 0;
    videoPlayer.currentTime(time);
    playerContainerFocused();
  }
}
